// import * as React from 'react';
// import Box from '@mui/material/Box';
// import Button from '@mui/material/Button';
// import Container from '@mui/material/Container';
// import IconButton from '@mui/material/IconButton';
// import Link from '@mui/material/Link';
// import Stack from '@mui/material/Stack';
// import TextField from '@mui/material/TextField';
// import Typography from '@mui/material/Typography';

// import FacebookIcon from '@mui/icons-material/GitHub';
// import LinkedInIcon from '@mui/icons-material/LinkedIn';
// import TwitterIcon from '@mui/icons-material/X';

// const logoStyle = {
//   width: '140px',
//   height: 'auto',
// };

// function Copyright() {
//   return (
//     <Typography variant="body2" color="text.secondary" mt={1}>
//       {'Copyright © '}
//       <Link href="https://mui.com/">Reseltech&nbsp;</Link>
//       {new Date().getFullYear()}
//     </Typography>
//   );
// }

// export default function Footer() {
//   return (
//     <Box
//       sx={{
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'center',
//         gap: { xs: 4, sm: 8 },
//         py: { xs: 8, sm: 10 },
//         textAlign: { sm: 'center', md: 'left' },
//         backgroundColor:"yellow"
//       }}
//     >
//       <Box
//         sx={{
//           display: 'flex',
//           flexDirection: { xs: 'column', sm: 'row' },
//           width: '100%',
//           justifyContent: 'space-between',
//         }}
//       >
//         <Box
//           sx={{
//             display: 'flex',
//             flexDirection: 'column',
//             gap: 4,
//             minWidth: { xs: '100%', sm: '60%' },
//           }}
//         >
//           <Box sx={{ width: { xs: '100%', sm: '60%' } }}>
//             <Box sx={{ ml: '-15px' }}>
//               <img
//                 src={
//                   'https://assets-global.website-files.com/61ed56ae9da9fd7e0ef0a967/61f12e6faf73568658154dae_SitemarkDefault.svg'
//                 }
//                 style={logoStyle}
//                 alt="logo of sitemark"
//               />
//             </Box>
//             <Typography variant="body2" fontWeight={600} gutterBottom>
//               Newsletter
//             </Typography>
//             <Typography variant="body2" color="text.secondary" mb={2}>
//               Subscribe to our newsletter for weekly updates and promotions.
//             </Typography>
//             <Stack direction="row" spacing={1} useFlexGap>
//             <TextField
//   id="outlined-basic"
//   hiddenLabel
//   size="small"
//   variant="outlined"
//   fullWidth
//   aria-label="Enter your email address"
//   placeholder="Your email address"
//   inputProps={{
//     autoComplete: 'off', // Corrected prop name
//     'aria-label': 'Enter your email address', // Corrected prop name
//   }}
// />

//               <Button variant="contained" color="primary" sx={{ flexShrink: 0 }}>
//                 Subscribe
//               </Button>
//             </Stack>
//           </Box>
//         </Box>
//         <Box
//           sx={{
//             display: { xs: 'none', sm: 'flex' },
//             flexDirection: 'column',
//             gap: 1,
//           }}
//         >
//           <Typography variant="body2" fontWeight={600}>
//             Product
//           </Typography>
//           <Link color="text.secondary" href="#">
//             Features
//           </Link>
//           <Link color="text.secondary" href="#">
//             Testimonials
//           </Link>
//           <Link color="text.secondary" href="#">
//             Highlights
//           </Link>
//           <Link color="text.secondary" href="#">
//             Pricing
//           </Link>
//           <Link color="text.secondary" href="#">
//             FAQs
//           </Link>
//         </Box>
//         <Box
//           sx={{
//             display: { xs: 'none', sm: 'flex' },
//             flexDirection: 'column',
//             gap: 1,
//           }}
//         >
//           <Typography variant="body2" fontWeight={600}>
//             Company
//           </Typography>
//           <Link color="text.secondary" href="#">
//             About us
//           </Link>
//           <Link color="text.secondary" href="#">
//             Careers
//           </Link>
//           <Link color="text.secondary" href="#">
//             Press
//           </Link>
//         </Box>
//         <Box
//           sx={{
//             display: { xs: 'none', sm: 'flex' },
//             flexDirection: 'column',
//             gap: 1,
//           }}
//         >
//           <Typography variant="body2" fontWeight={600}>
//             Legal
//           </Typography>
//           <Link color="text.secondary" href="#">
//             Terms
//           </Link>
//           <Link color="text.secondary" href="#">
//             Privacy
//           </Link>
//           <Link color="text.secondary" href="#">
//             Contact
//           </Link>
//         </Box>
//       </Box>
//       <Box
//         sx={{
//           display: 'flex',
//           justifyContent: 'space-between',
//           pt: { xs: 4, sm: 8 },
//           width: '100%',
//           borderTop: '1px solid',
//           borderColor: 'divider',
//         }}
//       >
//         <div>
//           <Link color="text.secondary" href="#">
//             Privacy Policy
//           </Link>
//           <Typography display="inline" sx={{ mx: 0.5, opacity: 0.5 }}>
//             &nbsp;•&nbsp;
//           </Typography>
//           <Link color="text.secondary" href="#">
//             Terms of Service
//           </Link>
//           <Copyright />
//         </div>
//         <Stack
//           direction="row"
//           justifyContent="left"
//           spacing={1}
//           useFlexGap
//           sx={{
//             color: 'text.secondary',
//           }}
//         >
//           <IconButton
//             color="inherit"
//             href="https://github.com/mui"
//             aria-label="GitHub"
//             sx={{ alignSelf: 'center' }}
//           >
//             <FacebookIcon />
//           </IconButton>
//           <IconButton
//             color="inherit"
//             href="https://twitter.com/MaterialUI"
//             aria-label="X"
//             sx={{ alignSelf: 'center' }}
//           >
//             <TwitterIcon />
//           </IconButton>
//           <IconButton
//             color="inherit"
//             href="https://www.linkedin.com/company/mui/"
//             aria-label="LinkedIn"
//             sx={{ alignSelf: 'center' }}
//           >
//             <LinkedInIcon />
//           </IconButton>
//         </Stack>
//       </Box>
//     </Box>
//   );
// }

import * as React from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
// import Link from '@mui/material/Link';
import { createTheme, ThemeProvider } from "@mui/material/styles";
// import logo from "../assets/footer/conova.png";
import logo from "../assets/footer/reseltech.jpg";
import qrcode from "../assets/footer/scanner.jpg";
import { Link } from "react-router-dom";

const logoStyle = {
  width: "100px",
  height: "80px",
  objectFit: "contain",
  borderRadius: "8px",
};

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 767,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
});

function Copyright() {
  return (
    <Typography
      variant="body1"
      color="white"
      sx={{ fontSize: "15px", cursor: "pointer" }}
    >
      {"Copyright © "}
      <Link href="http://aliRepairs.com/">&nbsp;</Link>
      {new Date().getFullYear()}
      &nbsp; RESELTECH &nbsp; All Rights Reserved{" "}
      {/* <Link sx={{ color: "white" }}>备:粤ICP备16102240号-1</Link> */}
    </Typography>
  );
}

export default function Footer() {
  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          background: "black",
          width: "100%",
          height: "50%",
          color: "white",
        }}
      >
        <Container
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: { xs: 1, sm: 2 },
            py: { xs: 1, sm: 1.5 },
            textAlign: { sm: "center", md: "left" },
          }}
        >
          <Box
            sx={{
              // display: 'flex',
              display: { xs: "none", sm: "flex" },
              flexDirection: { xs: "column", sm: "row" },
              width: "100%",
              justifyContent: "space-between",
              mt: "10px",
              // display: { xs: "none", sm: "flex" }
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 4,
                minWidth: { xs: "100%", sm: "60%" },
              }}
            >
              <Box
                sx={{
                  width: { md: "100%", xs: "100%", sm: "100%" },
                  mt: "40px",
                }}
              >
                <Box sx={{ ml: "0px", mb: "10px", p: 1 }}>
                  <img src={logo} style={logoStyle} alt="logo of AliRepairs" />
                   {/* <Typography
                variant="h6"
                //component="div"
                 component={Link}
                to="/"
                sx={{
                  fontWeight: "bold",
                  fontSize: "1.5rem",
                  color: "primary.main",
                  textDecoration: "none",
                  cursor: "pointer",
                  mr: 2,
                }}
              >
                Reseltech
              </Typography> */}
                </Box>
                {/* Here */}
                {/* <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                  <Typography   >Home</Typography>
                  <Box sx={{ width: '2px', height: '15px', backgroundColor: 'white', marginLeft: '8px', marginRight: '8px' }} />
                  <Typography>About&nbsp;Us</Typography>
                  <Box sx={{ width: '2px', height: '15px', backgroundColor: 'white', marginLeft: '10px', marginRight: '10px' }} />
                  <Typography>Technology</Typography>
                  <Box sx={{ width: '2px', height: '15px', backgroundColor: 'white', marginLeft: '10px', marginRight: '10px' }} />
                  <Typography>Downhole&nbsp;Tools</Typography>
                  <Box sx={{ width: '2px', height: '15px', backgroundColor: 'white', marginLeft: '10px', marginRight: '10px' }} />
                  <Typography>Contact&nbsp;Us</Typography>
                </Box> */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    component={Link}
                    to="/"
                    sx={{ color: "white", textDecoration: "none" }}
                  >
                    Home
                  </Typography>
                  <Box
                    sx={{
                      width: "2px",
                      height: "15px",
                      backgroundColor: "white",
                      marginLeft: "8px",
                      marginRight: "8px",
                    }}
                  />
                  <Typography
                    component={Link}
                    to="/about"
                    sx={{ color: "white", textDecoration: "none" }}
                  >
                    About Us
                  </Typography>
                  <Box
                    sx={{
                      width: "2px",
                      height: "15px",
                      backgroundColor: "white",
                      marginLeft: "10px",
                      marginRight: "10px",
                    }}
                  />
                  <Typography
                    component={Link}
                    to="/acidtech"
                    sx={{ color: "white", textDecoration: "none" }}
                  >
                    Technology
                  </Typography>
                  <Box
                    sx={{
                      width: "2px",
                      height: "15px",
                      backgroundColor: "white",
                      marginLeft: "10px",
                      marginRight: "10px",
                    }}
                  />
                  <Typography
                    component={Link}
                    to="/tool"
                    sx={{ color: "white", textDecoration: "none" }}
                  >
                    Downhole Tools
                  </Typography>
                  <Box
                    sx={{
                      width: "2px",
                      height: "15px",
                      backgroundColor: "white",
                      marginLeft: "10px",
                      marginRight: "10px",
                    }}
                  />
                  <Typography
                    component={Link}
                    to="/contact"
                    sx={{ color: "white", textDecoration: "none" }}
                  >
                    Contact Us
                  </Typography>
                </Box>
              </Box>
            </Box>
            {/* <Box sx={{ ml: "0px", mb: "10px", p: 2, mt: "" }}>
              <img src={qrcode} style={logoStyle} alt="logo of AliRepairs" />
              <Typography>follow official account</Typography>
            </Box> */}
            <Box
              sx={{
                // display: { xs: "none", sm: "flex" },
                  display: { xs: "none", sm: "flex" },
                flexDirection: "column",
                gap: 1,
                p: 1,
              }}
            >
              {/* <Typography variant="body2" fontWeight={600}>
                Telephone：+60 16-9582343
              </Typography> */}
               {/* <Typography variant="body2" fontWeight={600}>
                Telephone：+8613275425152
              </Typography> */}
               <Typography variant="body2" fontWeight={600}>
                Telephone：+8617561848489
              </Typography>
              {/* <Typography variant="body2" fontWeight={600}>
                Email： javed.86kn@gmail.com
                reseltech.rlt@gmail.com
              </Typography> */}
               {/* <Typography variant="body2" fontWeight={600}>
                Email： reseltech.rlt@gmail.com
              </Typography> */}
              {/* <Typography variant="body2" fontWeight={600}>
                Email： sak@reseltech.com
              </Typography> */}
              <Typography variant="body2" fontWeight={600}>
                Email： solution@reseltech.com
              </Typography>
               <Typography variant="body2" fontWeight={600}>
                Pakistan Address：Near PAF Colony, Opposite Govt. Primary School, Sohrab Wala, Tehsil and District Mianwali, Pakistan
              </Typography>
              {/* <Typography variant="body2" fontWeight={600}>
                Tehsil and District Mianwali, Pakistan
              </Typography> */}
              <Typography variant="body2" fontWeight={600}>
                China Address：Reseltech, No. 199, Huqiao Road, Xindu District, Chengdu, China
              </Typography>
              {/* <Typography variant="body2" fontWeight={600}>
                Optical Valley Software Park, Building 42, Qingdao, China.
              </Typography> */}
            </Box>
          </Box>

          {/* Disappear Section */}
          <Box
            sx={{
              width: "100%",
              height: "1px",
              background: "white",
              p: 0,
              mx: "0px",
              display: {
                xs: "none",
                sm: "block",
              },
            }}
          ></Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              justifyContent: "space-between",
              pt: { xs: 0.5, sm: 1.5 },
              width: "100%",
              flexShrink: 1,
              alignItems: "center",
              opacity: 0.5,
            }}
          >
            <Box
              sx={{
                width: { xs: "100%", sm: "50%" },
                display: "flex",
                flexDirection: "row",
                justifyContent: "left",
                alignItems: "left",
              }}
            >
              <Typography sx={{ textAlign: "left" }}>Links:</Typography>
              <Typography>RESELTECH</Typography>
              {/* <Box
                sx={{
                  width: "2px",
                  height: "15px",
                  backgroundColor: "white",
                  mx: "10px",
                  mt: "4px",
                }}
              />
              <Typography>CNOOC</Typography>
              <Box
                sx={{
                  width: "2px",
                  height: "15px",
                  backgroundColor: "white",
                  mx: "10px",
                  mt: "4px",
                }}
              />
              <Typography>ADNOC</Typography>
              <Box
                sx={{
                  width: "2px",
                  height: "15px",
                  backgroundColor: "white",
                  mx: "10px",
                  mt: "4px",
                }}
              /> */}
            </Box>
            <Box sx={{ width: "30%", display: { md: "none" } }}></Box>
            {/* <Box
              display={'flex'}
              direction="row"
              justifyContent="left"
              useFlexgap
            >
              <Copyright />
            </Box> */}
            <Box
              display="flex"
              flexDirection="row"
              justifyContent="left"
              sx={{
                gap: "8px", // Adjust the spacing value as needed
              }}
            >
              <Copyright />
            </Box>
          </Box>
        </Container>
      </Box>
    </ThemeProvider>
  );
}
